module.exports = {
  label: {
    tariffSettings: 'Tariff Settings',
    tariff: 'Tariff',
    scriptCreated:'Tariff amount updated successfully',
    contactDetail: 'Contact Details',
    tariffZero: "The Tariff amount should be less than 0",
    decimalErr: 'Please do not enter decimal values',
    contactNumber: 'Contact Number',
    email: 'Email',
    button: {
      save: 'Save'
    },
     validationMessages:{
        tariffRequired:'Please enter tariff amount',
        tariffMax:'Tariff amount must be between 0 and 100000'
    }
  }
};
